import { render, staticRenderFns } from "./DataTs1.vue?vue&type=template&id=b10411aa&scoped=true&"
import script from "./DataTs1.vue?vue&type=script&lang=js&"
export * from "./DataTs1.vue?vue&type=script&lang=js&"
import style0 from "./DataTs1.vue?vue&type=style&index=0&id=b10411aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10411aa",
  null
  
)

export default component.exports